import useCustomApi from '../../hooks/use-custom-api'
import {useQuery} from '@tanstack/react-query'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

/**
 * Fetches the precomputed list of master products available for Product Compare
 * within a given category. Backed by a Generic Mapping populated by the
 * createProductCompareData job and exposed via the product-compare custom SCAPI endpoint.
 * masterName is localized server-side based on the shopper's current locale.
 *
 * @param {string} categoryId - category to fetch comparable products for
 * @returns {{masterId: string, masterName: string, selectionId: string}[]} compare options
 */
export const useGetProductCompareData = (categoryId) => {
    const api = useCustomApi()
    const {locale} = useMultiSite()
    // sent hyphenated (e.g. "it-IT") - SCAPI treats "locale" as a reserved query param and
    // expects BCP-47 form; the endpoint normalizes to underscore to match the mapping's keys
    const localeId = locale?.id

    const {data: compareProducts} = useQuery(
        ['productCompareData', categoryId, localeId],
        async () => {
            const data = await api.getCategoryCompareProducts(categoryId, localeId)
            return Array.isArray(data) ? data : []
        },
        {enabled: Boolean(categoryId), staleTime: Infinity},
    )

    return compareProducts || []
}

export default useGetProductCompareData
